import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getBank } from '../redux/modules/bank';
import { getaddress } from '../redux/modules/address';
import { getDealer } from '../redux/modules/dealer';
import { createGuestPayment } from '../redux/modules/guestPayment';
import { notifSend } from '../redux/modules/notifs';
import NewAccountForm from '../components/NewAccountForm';
import { transformSelectorElementsToValues } from '../utils/form';
import { MESSAGES } from '../strings';

export class GuestPayment extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    bankDetails: PropTypes.object,
    dealerInfo: PropTypes.object,
    error: PropTypes.string,
    createGuestPayment: PropTypes.func.isRequired,
    getBank: PropTypes.func.isRequired,
    getaddress: PropTypes.func.isRequired,
    getDealer: PropTypes.func.isRequired,
    notifSend: PropTypes.func.isRequired, // eslint-disable-line react/no-unused-prop-types
    router: PropTypes.object.isRequired,
  };

  static defaultProps = {
    loading: false,
    bankDetails: null,
    dealerInfo: null,
    error: null,
  };

  componentWillReceiveProps = (nextProps) => {
    const { error, notifSend } = nextProps;
    if (error) {
      notifSend({
        message: error,
        kind: 'danger',
      });
    }
  };

  payment = (data) => {
    const { createGuestPayment } = this.props;
    return createGuestPayment(transformSelectorElementsToValues(data)).then(this.successPayment);
  };

  successPayment = (data) => {
    const { router, error } = this.props;
    if (!error) {
      router.push(
        `/operationComplete?message=${_.get(
          data,
          'message',
          MESSAGES.PAYMENT_SUBMITTED,
        )}&success=${_.get(data, 'success')}`,
      );
    }
    return data;
  };

  handleChangeDealerId = _.debounce((event) => {
    const dealerId = _.get(event, 'target.value');
    const { getDealer } = this.props;
    if (_.size(dealerId) === 4) {
      getDealer(dealerId);
    }
  }, 500);

  handleChangeRoutingNumber = _.debounce((event) => {
    const routingNumber = _.get(event, 'target.value');
    const { getBank } = this.props;
    if (_.size(routingNumber) === 9) {
      getBank(routingNumber);
    }
  }, 500);
  handleZipCodeChange = _.debounce((event) => {
    const zipCode = _.get(event, 'target.value');
    console.log('number of numbers', zipCode);
    const { getaddress } = this.props;
    if (_.size(zipCode) === 5) {
      getaddress(zipCode);
    }
  }, 500);

  render() {
    const { loading, dealerInfo, bankDetails } = this.props;
    return (
      <div className="container">
        <Helmet title="Guest Payment" />
        <NewAccountForm
          onSubmit={this.payment}
          dealerInfo={dealerInfo}
          bankDetails={bankDetails}
          onChangeDealerId={this.handleChangeDealerId}
          onChangeRoutingNumber={this.handleChangeRoutingNumber}
          onZipCodeChange={this.handleZipCodeChange}
          disableSubmit={loading}
        />
      </div>
    );
  }
}

export default connect(
  (state) => ({
    loading: state.page.loading,
    bankDetails: state.bank.details,
    dealerInfo: state.dealer.details,
    error: state.guestPayment.error,
  }),
  {
    getBank,
    getaddress,
    getDealer,
    createGuestPayment,
    notifSend,
  },
)(GuestPayment);
